module.exports = __webpack_public_path__ + "img/icon_flag.461d1366.png";